import type { ReactNode } from 'react';

export const symbol_note_alt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24.75 0-42.37-17.63Q120-155.25 120-180v-600q0-24.75 17.63-42.38Q155.25-840 180-840h205q5-35 32-57.5t63-22.5q36 0 63 22.5t32 57.5h205q24.75 0 42.38 17.62Q840-804.75 840-780v600q0 24.75-17.62 42.37Q804.75-120 780-120H180Zm0-60h600v-600H180v600Zm324.5-627.5Q515-818 515-832t-10.5-24.5Q494-867 480-867t-24.5 10.5Q445-846 445-832t10.5 24.5Q466-797 480-797t24.5-10.5ZM180-180v-600 600Zm121-109h33.13q5.52 0 10.69-2 5.18-2 10.18-7l246-246-59-61-247 247q-5 5-7 10.16-2 5.15-2 10.65v33.69q0 5.5 4.5 10T301-289Zm318-273 39-39q7-7 7.5-15.5T658-633l-29-28q-8-8-16-7.5t-15 7.5l-38 38 59 61Z"
		/>
	</svg>
);
